import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ScreenAge as ScreenAgeFemale } from '../../../OwnAI/screens/Age';
import { ScreenAge as ScreenAgeMale } from '../../../OwnAIMan/screens/Age';
import { LayoutDataType } from '../../types';

export const ScreenAge: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenAgeMale />;
  }

  return <ScreenAgeFemale />;
};
